import * as API from "@/api/request";

const comUrl = "/v1/workbench/feedback/";

export function saveFeedback(params) {
  return API.post(`${comUrl}submit`, params);
}
